type CoverFinding = {
  accepted?: boolean | null
  copyrights: readonly { id: string }[]
  audioBundle?: {
    acceptedWorks: readonly {
      fileId: string
      accepted: boolean
      matchSources: readonly string[]
    }[]
  } | null
}

export const isAcceptedCoverMatch = (finding: CoverFinding): boolean =>
  finding.accepted === true &&
  (finding.audioBundle?.acceptedWorks.some(
    (work) =>
      work.accepted &&
      work.matchSources.includes('audio_cover') &&
      finding.copyrights.some((file) => file.id === work.fileId)
  ) ??
    false)
